export const transformUserIds = (selectedHost) => {
  if (!Array.isArray(selectedHost)) return [];

  return selectedHost.map((host) => ({
    userId: host?.value,
    isPregnancy: host?.isPregnancy || false,
  }));
};
